import { formatDate } from '@btime/helpers'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useStockItemOperations } from '../_load/TransfersHistoryLoader'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const TransfersHistoryTable = () => {
  const { t } = useTranslation('listStocks')
  const data = useStockItemOperations()

  const columns = [
    {
      label: t('transfersHistory.table.date'),
      dataIndex: 'insertedAt',
      flex: 2,
      bold: true,
      sortIndex: false,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('transfersHistory.table.doneBy'),
      dataIndex: 'createdBy',
      flex: 2,
      sortIndex: false,
      format: prop('name')
    },
    {
      label: t('transfersHistory.table.operationType'),
      dataIndex: 'operationType',
      flex: 2,
      sortIndex: false,
      render: (data, _record) => {
        if (data === 'add_to_general') return <Text>{t('transfersHistory.operation.addToGeneral')}</Text>
        if (data === 'remove_general_stock') return <Text>{t('transfersHistory.operation.removeGeneralStock')}</Text>
        if (data === 'set_general_stock') return <Text>{t('transfersHistory.operation.setGeneralStock')}</Text>
        if (data === 'transfer_from_general_to_user')
          return <Text>{t('transfersHistory.operation.transferFromGeneralToUser')}</Text>
        if (data === 'transfer_from_user_to_general')
          return <Text>{t('transfersHistory.operation.transferFromUserToGeneral')}</Text>
        if (data === 'transfer_from_general_to_place')
          return <Text>{t('transfersHistory.operation.transferFromGeneralToPlace')}</Text>
        if (data === 'transfer_from_place_to_general')
          return <Text>{t('transfersHistory.operation.transferFromPlaceToGeneral')}</Text>
        if (data === 'self_use') return <Text>{t('transfersHistory.operation.selfUse')}</Text>
        return ''
      }
    },
    {
      label: t('transfersHistory.table.amount'),
      dataIndex: 'amount',
      flex: 2,
      sortIndex: false,
      render: data => <Text>{data}</Text>
    },
    {
      label: t('transfersHistory.table.origin'),
      flex: 2,
      sortIndex: false,
      render: (_data, record) => {
        if (record.operationType === 'add_to_general' || record.operationType === 'set_general_stock') {
          return ''
        }
        if (
          record.operationType === 'transfer_from_general_to_user' ||
          record.operationType === 'transfer_from_general_to_place'
        ) {
          return t('transfersHistory.generalStock')
        }
        if (record.fromUser) {
          return record.fromUser?.name
        }
        if (record.fromPlace) {
          return record.fromPlace?.name
        }
        return t('transfersHistory.generalStock')
      }
    },
    {
      label: t('transfersHistory.table.destination'),
      flex: 2,
      sortIndex: false,
      render: (_data, record) => {
        if (record.operationType === 'transfer_from_user_to_general') {
          return t('transfersHistory.generalStock')
        }
        if (record.operationType === 'self_use') {
          return ''
        }
        if (record.toUser) {
          return record.toUser?.name
        }
        if (record.toPlace) {
          return record.toPlace?.name
        }
        return t('transfersHistory.generalStock')
      }
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default TransfersHistoryTable
